import React, { useEffect, useCallback } from "react";
import { reportingThunk } from "../../../store/actions/reportingmanagement/reporting.thunk";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";

export const ReportIndex = () => {
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const { reporting } = useSelector((state) => state.reporting);
  const dispatch = useDispatch();

  console.log("report", reporting);

  const getReportings = useCallback(async () => {
    updateLoader(true, "Getting reports");
    await dispatch(reportingThunk.getReporting());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getReportings();
  }, []);
  return (
    <PageBody isLoading={isLoading} message={message}>
      <React.Fragment>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box-two">
                  <h4 className="page-title"></h4>
                  <h1 className="welcome_text">REPORT MANAGEMENT</h1>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className=" table-responsive">
                  <div className="table-title">
                    <div className="row">
                      <div className="col-sm-6">
                        <h2>
                          <b> REPORTING </b>{" "}
                        </h2>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-3 col-sm-12">
                      <div className="card-box-five widget-two-custom">
                        <div className="wigdet-two-content">
                          <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                            Employees{" "}
                            <span className="float-right font-light font-17">
                              {reporting.employees}
                            </span>
                          </p>
                          <div className="progress mt-2">
                            <div
                              className="progress-bar-second "
                              role="progressbar"
                              aria-valuenow="75"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              style={{
                                width: "100%",
                              }}
                            ></div>
                          </div>
                          <p className="m-0 text-uppercase font-bold float-left text-center">
                            {" "}
                            <span>
                              {" "}
                              {reporting.active_employees}
                            </span> <br></br> Active{" "}
                          </p>
                          <p className="m-0 text-uppercase font-bold float-right text-center">
                            {" "}
                            <span>{reporting.inactive_employees}</span>{" "}
                            <br></br> Inactive{" "}
                          </p>{" "}
                          <br></br>
                          <div className="clearfix"></div>
                          <div>
                            <Link to="/dashboard/report/employee">
                              {" "}
                              <p className="text-center ">
                                <small>View summary</small>{" "}
                              </p>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-sm-6">
                      <div className="card-box-five widget-two-custom">
                        <div className="wigdet-two-content">
                          <p
                            className="m-0 text-uppercase font-bold font-secondary text-overflow"
                            title="Statistics"
                          >
                            {" "}
                            Requests{" "}
                            <span className="float-right font-light font-17">
                              1
                            </span>{" "}
                          </p>

                          <div className="progress mt-2">
                            <div
                              className="progress-bar-second "
                              role="progressbar"
                              aria-valuenow="75"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              style={{
                                width: "100%",
                              }}
                            ></div>
                          </div>

                          <p className="m-0 text-uppercase font-bold float-left text-center">
                            {" "}
                            <span>
                              {reporting.office_requests}
                            </span> <br></br> Office{" "}
                          </p>
                          <p className="m-0 text-uppercase font-bold float-right text-center">
                            {" "}
                            <span>{reporting.individual_requests}</span>{" "}
                            <br></br> Individual{" "}
                          </p>
                          <div className="clearfix"></div>
                          <div>
                            <Link to="/dashboard/report/request">
                              {" "}
                              <p className="text-center ">
                                <small>View summary</small>{" "}
                              </p>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 card-box-five widget-two-custom">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="">
                            <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                              {" "}
                              Leave Request - {reporting.leave_requests}
                            </p>
                            <p className="m-0 text-uppercase font-bold">
                              Approved -{" "}
                              <span>
                                <small>
                                  {reporting.approved_leave_requests}
                                </small>
                              </span>
                            </p>
                            <p className="m-0 text-uppercase font-bold">
                              Rejected -{" "}
                              <span>
                                <small>
                                  {reporting.rejected_leave_requests}
                                </small>
                              </span>
                            </p>
                            <p className="m-0 text-uppercase font-bold">
                              Pending -{" "}
                              <span>
                                <small>
                                  {reporting.pending_office_requests}
                                </small>
                              </span>
                            </p>
                            <div>
                              <Link to="/dashboard/report/leave">
                                {" "}
                                <p className="text-center ">
                                  <small>View summary</small>{" "}
                                </p>
                              </Link>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="">
                            <div className="wigdet-two-content float-right">
                              <p className="m-0 text-uppercase font-bold font-secondary text-overflow text-right">
                                {" "}
                                {reporting.disciplinary_cases} - Disciplinary
                                Case
                              </p>

                              <p className="m-0 text-uppercase font-bold text-right">
                                {" "}
                                <span>
                                  <small> {reporting.open_cases} </small>
                                </span>{" "}
                                - Opened
                              </p>
                              <p className="m-0 text-uppercase font-bold text-right">
                                {" "}
                                <span>
                                  <small>{reporting.closed_cases} </small>
                                </span>{" "}
                                - Closed
                              </p>
                              <p></p>
                              <div>
                                <Link to="/dashboard/report/disciplinary-case">
                                  {" "}
                                  <p className="text-center ">
                                    <small>View summary</small>{" "}
                                  </p>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </PageBody>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/reportmanagement/index.js